export default {
	selectedBorderColor: "#005cac",
	selectedBorderWidth: 2,
	borderWidth: 1,
	borderRadius: 2,
	boldBorderRadius: 4,
	heavyBorderRadius: 8,
	thinBorderWidth: 1,
	panelTopPadding: 8,
	headerHeight: 64,
	bulletPixelSize: 31,
	button: { 
		wrapperButtonWidth: 146,
		wrapperHeight: 46,
		spaceMargin: 5,
		mediumSpaceMargin: 10,
		bigSpaceMargin: 20,
	},
	padding:{
		panelContainer:16
	},
	progressBar:{
		bigStorkeWidth: 40,
		horizontalBar:{
			height: 28,
			borderRadius: 6,  
		},
		textInProgressBar:{
			fontWeight: 500,
			lineHeight: 28,
			color: "#ffffff",
			marginLeft: 8,
		},
		TopicName:{
			fontSize: 12,
			textAlign: "left",
			color: "#5a6872",
		},
	},
	fontSize: {
		hint:12,
		content: 14,
		h1:24,
		header: 18,
		bold: 18,
		focusContent: 36,
	},
	lightFontWeight: 200,
	boldFontWeight: "bold",
	heavyFontWeidht: 500,
	form: {
		item:{
			marginBottom: 12,
		}
	},
	card:{
		paddingVertical: 18,
		paddingHorizontal: 30,
	},
	menuItem:{
		indentSize: 38
	},
    
	shadowDepth: 2,
	shadowBlur: 8,

	chart:{
		onClickDelay: 50,
		duration:750,
	}
};


// WEBPACK FOOTER //
// ./src/theme/Metrics.js